var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "103px",
    viewBox: "0 0 93 103",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000210169492 0.126107586 92.7414915 0.126107586 92.7414915 75.9997903 0.000210169492 75.9997903"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop_wireframes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_Home",
    transform: "translate(-758.000000, -3155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(758.000000, 3155.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#EC672B",
    points: "32 19 45 19 45 6 32 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#EC672B",
    points: "51 32 64 32 64 19 51 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#EC672B",
    points: "30 37 34 37 34 22 30 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#EC672B",
    points: "12 74 16 74 16 51 12 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#EC672B",
    points: "12 80 16 80 16 75 12 75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#EC672B",
    points: "60 75 64 75 64 70 60 70"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#EC672B",
    points: "65.8287132 0 65.8287132 4.82853704 61 4.82853704 61 9.17095233 65.8287132 9.17095233 65.8287132 14 70.1712868 14 70.1712868 9.17095233 75 9.17095233 75 4.82853704 70.1712868 4.82853704 70.1712868 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2734983,53.8413352 L81.7677017,53.8413352 L77.2994983,53.8413352 L57.4421593,53.8413352 C54.8350068,53.8413352 53.1263288,52.7563697 52.063922,50.4265766 C51.1664983,48.4579145 51.1397017,46.3828524 51.1397017,46.3707972 C51.1397017,43.0577214 52.1648034,40.730549 54.1866339,39.453749 C55.7681593,38.4557903 57.444261,38.4149076 57.4421593,38.4143834 L77.2994983,38.4143834 L81.7677017,38.4143834 L88.2734983,38.4143834 L88.2734983,53.8413352 Z M81.7677017,71.5430455 L88.2734983,71.5430455 L88.2734983,58.2986041 L81.7677017,58.2986041 L81.7677017,71.5430455 Z M4.46841356,16.5908524 L40.5944475,16.5908524 L45.0626508,16.5908524 L72.5911763,16.5908524 L72.7472271,16.585611 C72.7677186,16.5840847 74.7580237,16.5027972 76.0426847,17.6973076 C76.8765322,18.4730317 77.2994983,19.7173352 77.2994983,21.3945766 L77.2994983,33.9571145 L57.4421593,33.9571145 C57.3344475,33.9571145 46.6714983,34.0991559 46.6714983,46.3707972 C46.6714983,46.6669352 46.7067017,49.3431834 47.9267356,52.1158731 C49.6816508,56.1029903 53.0606508,58.2986041 57.4421593,58.2986041 L77.2994983,58.2986041 L77.2994983,71.5147421 L4.46841356,70.6011697 L4.46841356,16.5908524 Z M90.5076,0.130824828 L67.819278,0.130824828 L67.819278,4.58809379 L88.2734983,4.58809379 L88.2734983,33.9571145 L81.7677017,33.9571145 L81.7677017,21.3945766 C81.7677017,18.4311007 80.8666,16.0908248 79.0896169,14.4371697 C76.5518203,12.0769766 73.2258881,12.1000386 72.5291763,12.1335834 L45.0626508,12.1335834 L45.0626508,2.56125241 L40.5944475,2.56125241 L40.5944475,12.1335834 L4.46841356,12.1335834 L4.46841356,4.58337655 L25.858939,4.58337655 L25.858939,0.126107586 L2.23431186,0.126107586 L0.000210169492,2.35474207 L0.000210169492,12.1335834 L0.000210169492,16.5908524 L0.000210169492,72.8015007 L2.20593898,75.0301352 L77.2994983,75.9725352 L77.2994983,75.9997903 L90.5076,75.9997903 L92.7417017,73.7711559 L92.7417017,38.4143834 L92.7417017,33.9571145 L92.7417017,2.35945931 L90.5076,0.130824828 Z",
    id: "Fill-8",
    fill: "#EC672B",
    mask: "url(#mask-2)"
  })))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.0974ec0f.svg";
export { ForwardRef as ReactComponent };